import { maLookback } from '../../math/ma'
import { COLOR, line, matype, period } from '../../specs'
import type { IndicatorDef } from '../../types'

// Replaces the klinecharts KDJ (which stays as hidden KDJ v1 for existing instances).
const def: IndicatorDef = {
  id: 'STOCH',
  version: 1,
  label: 'Stochastic',
  pane: 'sub',
  category: 'momentum',
  series: 'normal',
  precision: 2,
  order: 30,
  inputs: [
    period('fastk_period', 5, '%K length', 1),
    period('slowk_period', 3, '%K smoothing', 1),
    matype('slowk_matype', 0, '%K MA type'),
    period('slowd_period', 3, '%D smoothing', 1),
    matype('slowd_matype', 0, '%D MA type'),
  ],
  outputs: [line('slowk', '%K', COLOR.blue), line('slowd', '%D', COLOR.orange)],
  levels: [{ value: 80 }, { value: 20 }],
  talib: {
    functions: ['STOCH'],
    expr: 'STOCH(high, low, close, fastk_period={fastk_period}, slowk_period={slowk_period}, slowk_matype={slowk_matype}, slowd_period={slowd_period}, slowd_matype={slowd_matype})',
    outputs: { slowk: 'slowk', slowd: 'slowd' },
  },
  listed: true,
  tailSafe: true,
  lookback: ({ fastk_period, slowk_period, slowk_matype, slowd_period, slowd_matype }) =>
    fastk_period - 1 + maLookback(slowk_period, slowk_matype) + maLookback(slowd_period, slowd_matype),
}
export default def
